import {Button, Heading, Stack, Table, VStack} from "@chakra-ui/react";
import React, {useCallback, useEffect, useState} from "react";
import {CompanyExecutorFull, dataApi} from "../../api/data-api";
import {useToast} from "@chakra-ui/toast";
import {useRecoilState} from "recoil";
import {companyData, companyOperatorsData, userLoginResultData} from "../../components/hooks/recoilData";
import {DateTime} from "luxon";
import {checkAccess} from "../../components/hooks/CommonUtils";
import ExecutorItem from "./executorItem";

/*
export interface CompanyExecutorEx {
    ID: number,
    COMPANY_ID: number,
    EXECUTOR_ID: number,
    CREATED: number,
    CONFIRMED: number,
    USER_ID: number,
    FIRST_NAME: string,
    SECOND_NAME: string,
    LAST_NAME: string,
    INN: string,
}
*/

export const Executor = () => {
        const [items, setItems] = useState<CompanyExecutorFull[]>([]);
        const toast = useToast();
        const [company] = useRecoilState(companyData);
        // const [currentExecutor, setCurrentExecutor] = useState<CompanyExecutorFull>();
        // const [show, setShow] = useState<boolean>(false);
        const [showItem, setShowItem] = useState<boolean>(false);
        const [currentItem, setCurrentItem] = useState<CompanyExecutorFull | null>(null);
        const [userLoginResult] = useRecoilState(userLoginResultData);
        const [companyOperators] = useRecoilState(companyOperatorsData);

        useEffect(() => {
            if (company) {
                dataApi.companyExecutorListFull(company.ID)
                // .then((o) => Promise.allSettled(o
                //     .map((o2) => o2 as CompanyExecutorEx)
                //     .map(o2 => {
                //         return dataApi.executorGet(o2.EXECUTOR_ID)
                //             .then(o3 => {
                //                 o2.USER_ID = o3.USER_ID;
                //                 return userApi.profileGet(o3.USER_ID);
                //             })
                //             .then(o4 => {
                //                 o2.FIRST_NAME = o4.FIRST_NAME;
                //                 o2.SECOND_NAME = o4.SECOND_NAME;
                //                 o2.LAST_NAME = o4.LAST_NAME;
                //                 return o2;
                //             });
                //     })))
                // .then(l => {
                //     setItems(l
                //         .filter(v => v.status === 'fulfilled')
                //         .map(v => ((v as object) as PromiseFulfilledResult<CompanyExecutorEx>).value));
                // })
                    .then(o => {
                        setItems(o);
                    })
                    .catch((err) => {
                        console.log("Error status code is: " + err);
                        toast({title: "Error", description: `code: [${err}]`, status: "error"});
                    });
            }
        }, [company, toast]);

        const confirm = useCallback((item: CompanyExecutorFull) => {
            if (!item)
                return;
            setCurrentItem(item);
            dataApi.companyExecutorConfirm(item.ID)
                .then((o) => {
                    if (o) {
                        toast({title: "Confirm", status: "success"});
                        item.CONFIRMED = new Date().getTime();
                        setItems(prev => {
                            const lst = [...prev];
                            let index = lst.indexOf(item);
                            if (index > -1)
                                lst[index] = item;
                            return lst;
                        });
                    } else {
                        toast({title: "Confirm failed", status: "error"});
                    }
                })
                .catch((err) => {
                    console.log("Error status code is: " + err);
                    toast({title: "Error", description: `code: [${err}]`, status: "error"});
                });
        }, [toast]);

        // const showDlg = useCallback((item: CompanyExecutorFull) => {
        //     setCurrentExecutor(item);
        //     setShow(!!item)
        // }, []);

        const goToItem = useCallback((item: CompanyExecutorFull | null) => {
            setShowItem(true);
            setCurrentItem(item);
        }, []);

        const goToItems = useCallback(() => {
            setShowItem(false);
            setCurrentItem(null);
        }, []);

        let checkAccessEdit = checkAccess(userLoginResult, company, companyOperators, "EDIT");

        return showItem ?
            <>
                <Button onClick={e => goToItems()}>
                    Назад
                </Button>
                <ExecutorItem executor={currentItem as any}/>
            </>
            :
            <VStack>
                <Stack width="full" gap="5">
                    {/*<ExecutorContract executor={currentExecutor} isCompany={true} show={show} setShow={setShow}/>*/}
                    <Heading size="xl">Исполнители</Heading>
                    <Table.Root size="sm" variant="outline" striped>
                        <Table.Header>
                            <Table.Row>
                                {/*<Table.ColumnHeader>Компания</Table.ColumnHeader>*/}
                                {/*<Table.ColumnHeader>Executor id</Table.ColumnHeader>*/}
                                {/*<Table.ColumnHeader>Пользователь</Table.ColumnHeader>*/}
                                <Table.ColumnHeader>ФИО и ИНН</Table.ColumnHeader>
                                <Table.ColumnHeader>Cтатус</Table.ColumnHeader>
                                <Table.ColumnHeader>Добавлен</Table.ColumnHeader>
                                <Table.ColumnHeader>Мой налог</Table.ColumnHeader>
                                <Table.ColumnHeader>НПД</Table.ColumnHeader>
                                <Table.ColumnHeader>Договор</Table.ColumnHeader>
                                <Table.ColumnHeader>ПДн</Table.ColumnHeader>
                                <Table.ColumnHeader>Эдо</Table.ColumnHeader>
                                <Table.ColumnHeader>Оплата</Table.ColumnHeader>
                                <Table.ColumnHeader>Подтвержден</Table.ColumnHeader>
                                <Table.ColumnHeader>Действия</Table.ColumnHeader>
                            </Table.Row>
                        </Table.Header>
                        <Table.Body>
                            {items.map((item) => (
                                <Table.Row key={item.ID}>
                                    {/*<Table.Cell>{item.COMPANY_ID}</Table.Cell>*/}
                                    {/*<Table.Cell>{item.EXECUTOR_ID}</Table.Cell>*/}
                                    {/*<Table.Cell>{item.USER_ID}</Table.Cell>*/}
                                    <Table.Cell>{`${item.FIRST_NAME} ${item.SECOND_NAME} ${item.LAST_NAME} ${item.CODE_INN}`}</Table.Cell>
                                    <Table.Cell>{item.NALOG_STATUS}</Table.Cell>
                                    <Table.Cell>{item.CREATED ? DateTime.fromMillis(item.CREATED).toFormat('HH:mm:ss dd.MM.yyyy') : ""}</Table.Cell>
                                    <Table.Cell>{item.NALOG_NPD}</Table.Cell>
                                    <Table.Cell>{item.NALOG_ALLOW_PAYMENT ? "true" : "false"}</Table.Cell>
                                    <Table.Cell>{item.DOCUMENT_SIGN_1 ? "true" : "false"}</Table.Cell>
                                    <Table.Cell>{item.DOCUMENT_SIGN_2 ? "true" : "false"}</Table.Cell>
                                    <Table.Cell>{item.DOCUMENT_SIGN_3 ? "true" : "false"}</Table.Cell>
                                    <Table.Cell>{item.WITHDRAW_TYPE}</Table.Cell>
                                    <Table.Cell>{item.CONFIRMED ? DateTime.fromMillis(item.CONFIRMED).toFormat('HH:mm:ss dd.MM.yyyy') : ""}</Table.Cell>
                                    <Table.Cell>
                                        {/*<Button onClick={e => showDlg(item)}>Contracts</Button>*/}
                                        <Button onClick={e => goToItem(item)}>Карточка</Button>
                                        <Button display={item.CONFIRMED ? "none" : "block"} disabled={!checkAccessEdit} onClick={e => confirm(item)}>Подтвердить</Button>
                                    </Table.Cell>
                                </Table.Row>
                            ))}
                        </Table.Body>
                    </Table.Root>

                </Stack>
            </VStack>
    }
;